// Initialize SIAP settings behaviors
document.addEventListener("turbolinks:load", () => {
  // On change competition select on SIAP fixture settings form
  $("#siap_setting_competition").on("change", function () {
    var competitionId = $(this).val();
    var roundSelect = $("#siap_setting_round");

    if (competitionId) {
      $.ajax({
        method: "PUT",
        url: "/fixtures/update_rounds",
        data: { competition_id: competitionId },
        dataType: "json",
      }).done(function (result) {
        roundSelect.find("option").remove();

        roundSelect.append(`<option value=""></option>`);
        $.each(result.rounds, function (index, round) {
          roundSelect.append(
            `<option value="${round.id}">${round.name}</option>`
          );
        });

        roundSelect.prop("disabled", false);
      });
    } else {
      roundSelect.find("option").remove();
      roundSelect.prop("disabled", true);
    }
  });
});
